var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMapIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50008 0.416748C3.59433 0.416748 0.416748 3.59433 0.416748 7.50008C0.416748 11.4058 3.59433 14.5834 7.50008 14.5834C11.4058 14.5834 14.5834 11.4058 14.5834 7.50008C14.5834 3.59433 11.4058 0.416748 7.50008 0.416748ZM1.83341 7.50008C1.83341 6.86329 1.94391 6.252 2.13871 5.68037L3.25008 6.79175L4.66675 8.20842V9.62508L6.08342 11.0417L6.79175 11.7501V13.1179C4.00162 12.7672 1.83341 10.3844 1.83341 7.50008ZM11.9838 10.9518C11.5213 10.5792 10.82 10.3334 10.3334 10.3334V9.62508C10.3334 9.24936 10.1842 8.88902 9.91848 8.62335C9.65281 8.35767 9.29247 8.20842 8.91675 8.20842H6.08342V6.08342C6.45914 6.08342 6.81947 5.93416 7.08515 5.66848C7.35083 5.40281 7.50008 5.04247 7.50008 4.66675V3.95841H8.20842C8.58414 3.95841 8.94447 3.80916 9.21015 3.54348C9.47583 3.27781 9.62508 2.91747 9.62508 2.54175V2.25062C11.6991 3.09283 13.1667 5.12717 13.1667 7.50008C13.1666 8.75008 12.7504 9.96447 11.9838 10.9518V10.9518Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMapIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/map-icon.7319c611e7f086fe83fb4eff2c6539ce.svg";